import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import services from 'services';
import { Timezone } from 'types';

import MobileRadioGroupPreference from '../MobileRadioGroupPreference/MobileRadioGroupPreference';

const DISPLAY_TIMEZONES = [Timezone.UTC_WITH_LOCAL, Timezone.UTC, Timezone.LOCAL];

const MobileTimezoneSelector = () => {
  const { t } = useTranslation();
  const [selectedTimezone, setSelectedTimezone] = useState(services.appFrame.timezone.getTimezone());

  const handleSelectZone = useCallback((event) => {
    setSelectedTimezone(event.target.value);
    services.appFrame.timezone.setTimezone(event.target.value as Timezone);
  }, []);

  useEffect(() => {
    return services.appFrame.timezone.onTimezoneChange((newTimezone) => {
      setSelectedTimezone(newTimezone);
    });
  }, []);

  const items = useMemo(
    () =>
      DISPLAY_TIMEZONES.map((item) => ({
        label: t(`timezone.${item.toString().toLowerCase()}`),
        value: item,
      })),
    [t],
  );

  return (
    <MobileRadioGroupPreference
      data-testid="MobileTimezoneSelector-root"
      title={t('timezone.title')}
      value={selectedTimezone}
      items={items}
      onChange={handleSelectZone}
    />
  );
};

export default MobileTimezoneSelector;
